import { OnDemandProgramVariation } from '@/hooks/PDP/useProgramCatalogRelations';
import Shimmer from '../Shimmer';
import Icon from '../Icon';
import { useContentOptOut } from '@/hooks/PDP/useContentOptOut';
import { isContentRestricted, isNotContentRestricted } from './helpers';

export interface ContentOptOutTout {
  program?: OnDemandProgramVariation;
  isProgramSegmentsLoading?: boolean;
}

export const ContentOptOutTout = ({ program, isProgramSegmentsLoading }: ContentOptOutTout) => {
  const { contentOptOut: profileContentOptOut } = useContentOptOut();

  // Only display IF program is restricted (program interestAreas <=> contentOptOut) AND not all segments are restricted (segment interestAreas <=> contentOptOut)
  const programIsRestricted = isContentRestricted(program, profileContentOptOut);
  const programHasNonRestrictedSegments = program?.segments?.some(seg =>
    isNotContentRestricted(seg, profileContentOptOut)
  );

  const loadingShimmer = (
    <div className="container py-6 md:py-10">
      <Shimmer className="h-[72px] w-full rounded  px-6 py-[18px]" />
    </div>
  );

  if (!profileContentOptOut?.length) return <></>;

  if (profileContentOptOut?.length && isProgramSegmentsLoading) return loadingShimmer;

  if (!programIsRestricted) return <></>;

  if (programIsRestricted && !programHasNonRestrictedSegments) return <></>;

  return (
    <div className="container py-6 md:py-10">
      <a
        href="#segments"
        className="flex w-full flex-col gap-2 rounded bg-gray-lightest px-6 py-[28px] text-gray-darker hover:bg-gray-light sm:flex-row"
      >
        <Icon name="check" size="medium" />
        <span className="text-2-medium">
          Some segments in this program are included in your membership.{' '}
          <a href="#segments" className="underline transition hover:text-red">
            Explore included segments
          </a>
        </span>
      </a>
    </div>
  );
};
